import React, { useEffect, useRef, useState } from 'react';

import OmniverseLogo from 'asset/omniverse-logo.png';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import DOMPurify from 'isomorphic-dompurify';

import ArrowLeft from 'components/Icons/ArrowLeft';

import VideoExamples from './Carousel';
import { data_hero } from './content';

export default function Hero() {
  const { items } = data_hero;

  const [activeSlide, setActiveSlide] = useState(0);
  const [isUserPerformAction, setIsUserPerformAction] = useState(false);
  const timeoutRef = useRef(null);

  function onUserActions() {
    setIsUserPerformAction(true);
    setTimeout(() => setIsUserPerformAction(false), 30000);
  }

  function handleNext() {
    setActiveSlide(activeSlide + 1);
    onUserActions();
  }

  function handlePrev() {
    setActiveSlide(activeSlide - 1);
    onUserActions();
  }

  function handleAuto(delay) {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    let newState = activeSlide === 0 ? 1 : 0;

    if (isUserPerformAction) {
      delay = 35000;
    }

    timeoutRef.current = setTimeout(() => {
      setActiveSlide(newState);
    }, delay);
  }

  useEffect(() => {
    let delay = 18000;
    handleAuto(delay);
  }, [activeSlide]);

/*  useEffect(() => {
    const firstVideo = document.querySelector('#video-1');

    if (document.hidden) return;

    if (firstVideo) {
      const playVideo = () => {
        if (!document.hidden) firstVideo.play();
      };

      const pauseVideo = () => {
        if (!document.hidden) firstVideo.pause();
      };

      setTimeout(() => {
        pauseVideo();
      }, 3650);

      setTimeout(() => {
        playVideo();
      }, 9000);
    }
  }, [activeSlide]);*/

  const btnStyles = 'w-8 h-8 p-2 group';

  return (
    <section className="hero sm:gl-wrapper-y flex w-full overflow-hidden">
      <div className="gl-wrapper relative flex min-h-[calc(100vh-96px)] 1100:min-h-fit sm:py-0 py-8 items-center lg:min-h-fit">
        <div className="relative z-10 flex h-full max-w-[50%] flex-col items-start justify-center 1100:max-w-full">
          <img className="z-[24] mb-7 max-w-[11.625rem] sm:hidden" src={OmniverseLogo} alt="NVIDIA Omniverse logo" />

          <h1
            className="gl-heading-1 text-white [&>span]:font-Proxima [&>span]:text-demo-xr-blue"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data_hero.title) }}
          />

          <VideoExamples items={items} btnStyles={btnStyles} />

          <div
            className="mt-9 text-[1.75rem] leading-[1.25] text-white lg:mt-6 lg:max-w-[100%] lg:text-[20px]"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data_hero.description) }}
          />
          <img
            className="z-[24] mt-7 max-w-[11.625rem] min-sm:hidden"
            src={OmniverseLogo}
            alt="NVIDIA Omniverse logo"
          />
        </div>

        <div className="relative w-full max-w-[45%] 1100:!hidden">
          <div className="absolute w-[52vw] -translate-y-1/2">
            <div className="aspect-video size-full">
              <AnimatePresence>
                <motion.video
                  id={`video-${activeSlide + 1}`}
                  initial={{ width: '1px', opacity: 0, scale: 1 }}
                  animate={{ width: '100%', opacity: 1, scale: activeSlide === 1 ? 1.25 : 1 }}
                  exit={{ width: '1px', opacity: 0, scale: 1 }}
                  transition={{ duration: 0.85 }}
                  key={items[activeSlide].id}
                  loop={activeSlide === 1}
                  muted
                  autoPlay
                  playsInline
                  className={cn(
                    'aspect-video',
                    activeSlide === 0 && 'ml-0',
                    activeSlide === 1 && 'relative bottom-[3rem] right-[2.25vw] scale-[1.25] object-right-top',
                  )}
                >
                  <source src={items[activeSlide].video}></source>
                </motion.video>
              </AnimatePresence>
            </div>
            <motion.div
              initial={{ width: '1px', opacity: 0 }}
              animate={{ width: '100%', opacity: 1 }}
              exit={{ width: '1px', opacity: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="gl-wrapper relative z-[12] ml-[6rem] mt-8 flex max-w-[calc(calc(64rem)/2)] gap-5 1100:!ml-7 1100:!max-w-[75%] 1300:ml-0 1300:px-0"
            >
              <div className="progress relative flex w-full items-center">
                <div
                  style={{ width: `calc(100%/${items.length}`, translate: `calc(100%*${activeSlide})` }}
                  className="absolute h-[7px] bg-demo-xr-blue transition-all duration-500"
                />
                <hr className="w-full" />
              </div>
              <div className="flex gap-2">
                <button
                  disabled={activeSlide === 0}
                  className={cn(btnStyles, 'disabled:cursor-not-allowed disabled:opacity-50')}
                  onClick={handlePrev}
                >
                  <ArrowLeft className="h-full w-full fill-white group-hover:fill-demo-xr-blue group-disabled:!fill-white" />
                </button>
                <button
                  disabled={activeSlide === items.length - 1}
                  className={cn(btnStyles, 'disabled:cursor-not-allowed disabled:opacity-50')}
                  onClick={handleNext}
                >
                  <ArrowLeft className="h-full w-full rotate-180 fill-white group-hover:fill-demo-xr-blue group-disabled:!fill-white" />
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}


/*

  const [activeVideo, setActiveVideo] = React.useState(0);
  const [userInterrupted, setUserInterrupted] = React.useState(false);


  function toggleVideo(idx) {
    setActiveVideo(idx);
    setUserInterrupted(true);
  }

  useEffect(() => {
    let delay = activeVideo === 0 ? 5000 : 6000;

    if (userInterrupted) {
      delay += 10000;

      setTimeout(() => {
        setUserInterrupted(false);
      }, delay);
    }

    setTimeout(() => {
      setActiveVideo(activeVideo === 0 ? 1 : 0);
    }, delay);
  }, [activeVideo]);

  useEffect(() => {
    const video = document.querySelector(`#video-${activeVideo}`);

    video.addEventListener('canplay', () => {
      setTimeout(() => {
        video.play();
      }, 1000);
    });
  }, [activeVideo]);

*/

/*
<section
  className="hero sm:gl-wrapper-y relative flex min-h-[100vh] flex-col items-center justify-center overflow-hidden !pt-11 pb-11">
  <AnimatePresence>
    <motion.video
      id={`video-${activeVideo}`}
      initial={{ y: '-100%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '50%', opacity: 0 }}
      transition={{ duration: 1 }}
      key={items[activeVideo].id}
      className="absolute bottom-0 right-0 h-full w-full max-w-[48%] object-contain object-center pt-[5.5vw] sm:static sm:pt-0"
      muted
      loop={activeVideo === 1}
    >
      <source src={items[activeVideo].video} type="video/webm" />
    </motion.video>
  </AnimatePresence>

  <div className="gl-wrapper relative z-10 flex h-full flex-col items-start justify-center">
    <h1
      className="gl-heading-1 text-white [&>span]:font-Proxima [&>span]:text-demo-xr-blue"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data_hero.title) }}
    />

    <div
      className="mt-9 max-w-[50%] text-[1.75rem] leading-[1.25] text-white lg:mt-6 lg:max-w-[100%] lg:text-[20px]"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data_hero.description) }}
    />
  </div>

  <div className="absolute bottom-[1rem] sm:hidden">
    <div className="flex items-center justify-center gap-4">
      {items.map((item, idx) => (
        <div
          key={item.id}
          className={cn(
            'relative before:transition-all before:duration-700',
            thumbCircle,
            idx === activeVideo && 'before:bg-demo-xr-blue',
          )}
        >
          <img
            onClick={() => toggleVideo(idx)}
            className={cn(
              'relative w-full max-w-[96px] cursor-pointer border-demo-xr-blue transition-all duration-700',
              idx === activeVideo ? '!max-w-[128px] drop-shadow' : 'grayscale',
            )}
            src={item.thumb}
          />
        </div>
      ))}
    </div>
  </div>
</section>
*/
